import { useEffect } from 'react'
import { useClearOnUnmount, useFieldHelpers } from '@/base'
import { Input, InputProps } from '../../atoms/input'
import { FormField, FormFieldProps } from '.'

export const FormInput = (
  props: Omit<InputProps, 'onChange' | 'value'> &
    Omit<FormFieldProps, 'children'> & {
      onChangeCallback?: (_?: string) => void
      shouldClearOnDismount?: boolean
      componentType?:
        | 'currency'
        | 'number'
        | 'phone'
        | 'pattern'
        | 'location'
        | 'date'
      format?: string
    }
) => {
  const {
    onChangeCallback,
    placeholder,
    name,
    label,
    schema,
    shouldClearOnDismount,
    componentType,
    format,
  } = props
  const { field, helpers } = useFieldHelpers({ name, schema })
  useClearOnUnmount(shouldClearOnDismount, helpers.setValue)

  useEffect(() => {
    if (onChangeCallback) {
      onChangeCallback(field.value)
    }
  }, [field.value, onChangeCallback])

  const placeholderOrLabel =
    placeholder || (typeof label === 'string' ? label : undefined)

  return (
    <FormField
      name={name}
      label={label}
      schema={schema}
      message={props.message}
      description={props.description}
      optionalText={props.optionalText}
      errorTestId={`error-${name}`}
    >
      <Input
        placeholder={placeholderOrLabel}
        componentType={componentType}
        format={format}
        {...props}
        {...field}
        value={field.value ?? ''}
        onChange={(e) => helpers.setValue(e.target.value)}
      />
    </FormField>
  )
}
